import { ITableHeader } from '@base/@types/components/Layout/TableGrid'
import { IParamsToSend } from '@base/@types/providers/Otb/FollowUpProvider'

export const validateIfShowColumnInTable = (
  headers: ITableHeader[],
  paramsToSend: IParamsToSend
) => {
  let newHeaders: ITableHeader[] = []
  newHeaders = [...headers]

  newHeaders = [...headers]

  const headersFormatted: ITableHeader[] = newHeaders.map(item => {
    return (item = {
      group: item.group,
      columns: item.columns.map(column => {
        if (column.id === 'empresa-codigo') {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.empresa.agrupar
          })
        }

        if (
          column.id === 'categoria-compacta-descricao' ||
          column.id === 'categoria-compacta-codigo'
        ) {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.categoriaCompacta.agrupar
          })
        }
        if (
          column.id === 'categoria-codigo' ||
          column.id === 'categoria-descricao'
        ) {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.categoria.agrupar
          })
        }
        if (column.id === 'mundo-codigo' || column.id === 'mundo-descricao') {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.mundo.agrupar
          })
        }
        if (
          column.id === 'gerente-categoria-codigo' ||
          column.id === 'gerente-categoria-descricao'
        ) {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.gerenteCategoria.agrupar
          })
        }
        if (
          column.id === 'gerente-produto-codigo' ||
          column.id === 'gerente-produto-descricao'
        ) {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.gerenteProduto.agrupar
          })
        }
        if (
          column.id === 'produto-codigo' ||
          column.id === 'produto-descricao'
        ) {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.produto.agrupar
          })
        }

        return column
      })
    })
  })

  return headersFormatted
}
